export default "__VITE_ASSET__CRMhMJ6y__"